import {
    SkyNetObjectConfigParams,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'

// eslint-disable-next-line import/prefer-default-export
export const prepareMasterConfig = (domainConfig: SkyNetObjectConfigParams<any>) => {
    return domainConfig.config.map((tabConfig) => {
        return {
            ...tabConfig,
            columns: tabConfig.columns || domainConfig.columns,
            formViews: tabConfig.formViews || domainConfig.formViews,
        }
    })
}
